import React, { useEffect } from "react";
import {
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Box,
} from "@material-ui/core";
export default function POAlertDialog({
  setAlertMessage,
  message,
  setErrAlertMessage,
}) {
  const [open, setOpen] = React.useState(false);
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setAlertMessage(false);
    // setErrAlertMessage("")
  };
  useEffect(() => {
    handleClickOpen();
  }, []);
  return (
    <Dialog open={open} onClose={handleClose} fullWidth={true}>
      <DialogContent>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          p={2}
          mt={1}
        >
          <Typography variant="h3" style={{ width: "80%" }}>
            {/*{message ? message : "All invoices are consumed"}*/}
            {message}
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
          }}
          m={1}
        >
          <Button variant="contained" color="secondary" onClick={handleClose}>
            OK
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
